<template>
  <v-container>
    <v-row v-for="(sectionRoutes, section) in groupedRoutes" :key="section">
      <v-col cols="12">
        <v-divider></v-divider>
        <v-subheader>{{ section }}</v-subheader>
      </v-col>
      <v-col v-for="route in sectionRoutes" :key="route.name" cols="12" sm="6" md="4">
        <v-card @click="handleCardClick(route.path)" class="mx-auto card-spacing" max-width="300">
          <v-card-title>
            <v-icon>{{ route.icon || "mdi-alert" }}</v-icon>
            {{ route.name || "Untitled" }}
          </v-card-title>
          <v-card-subtitle>
            {{ route.description || "No description available" }}
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <!-- Warning Snackbar -->
    <v-snackbar v-model="warning" :color="warningColor" :timeout="3000">
      {{ warningMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: "LandingPage",
  data() {
    return {
      warning: false, // Controls the visibility of the warning snackbar
      warningMessage: "", // Stores the warning message
      warningColor: "red", // Warning color (default: red)
    };
  },
  computed: {
    club() {
      return this.$store.state.club;
    },
    groupedRoutes() {
      //console.log("club from store state", this.club);

      return this.$router.options.routes.reduce((sections, route) => {
      //  const hasClubAccess = !route.requiresClub || (route.requiresClub && this.club);
      //  const hasLeagueAccess = !route.requiresLeague || (route.requiresLeague && this.$store.getters.league);

        if (route.show !== 0 && route.section) {
          if (!sections[route.section]) {
            sections[route.section] = [];
          }
          sections[route.section].push(route);
        }
        return sections;
      }, {});
    },
  },
  methods: {
    handleCardClick(path) {
      // Check if the route path references :club or :league
      const requiresClub = path.includes(":club");
      const requiresLeague = path.includes(":league");
      const missingParams = [];
      console.log("club:" + this.$store.getters.club);
      console.log("league:" + this.$store.getters.league);
      if (requiresClub && !this.$store.getters.club) {
        missingParams.push("club");
      }
      if (requiresLeague && !this.$store.getters.league) {
        missingParams.push("league");
      }

      if (missingParams.length) {
        // Show warning if necessary parameters are missing
        this.warningMessage = `Please select ${missingParams.join(" and ")}.`;
        this.warningColor = "orange"; // Set a distinct warning color
        this.warning = true;
      } else {
        // Navigate to the resolved path
        const fullPath = this.generateFullPath(path);
        window.location.href = fullPath;
      }
    },
    generateFullPath(path) {
      let fullPath = path;
      if (this.$store.getters.club) {
        fullPath = fullPath.replace(":club", this.$store.getters.club);
      }
      if (this.$store.getters.league) {
        fullPath = fullPath.replace(":league", this.$store.getters.league);
      }
      return this.$router.resolve({ path: fullPath }).href;
    },
  },
  mounted() {
    console.log("landingmain");
    console.log(this.$store);
    console.log(this.$store.state.club);
    //        this.status_selected = catValueListArray('athlete_status');
  },
};
</script>

<style scoped>
.card-spacing {
  margin: 10px;
  max-width: 250px;
  cursor: pointer;
}

.v-card-title {
  font-weight: bold;
}

.v-icon {
  margin-right: 10px;
}
</style>
